
export function getExtensionOfFile(fileName) {
  let extension = (/[.]/.exec(fileName)) ? /[^.]+$/.exec(fileName)[0] : undefined;
  if (extension !== undefined) extension = extension.toLowerCase();
  return extension;
}

export function getMimeType(extension) {
  extension = extension.toLowerCase();
  if (extension === "png") return "image/png";
  if (extension === "jpeg" || extension === "jpg") return "image/jpeg";
  if (extension === "bmp") return "image/bmp";
  if (extension === "pdf") return "application/pdf";
  return "text/plain"
}

export function getSizeInMB(byteSize) {
  let sizeMB = byteSize / 1024 / 1024;
  sizeMB = (parseInt((sizeMB * 10) + 0.5, 10)) / 10.0;
  return sizeMB;
}

export default{
  getExtensionOfFile,
  getMimeType,
  getSizeInMB
}
